'use strict';

var liveFormValidation = require('theme/js/components/liveFormValidation');

liveFormValidation($('form'));
